import { getUser } from './auth'

/**
 * 判断是否有权限
 * @param {string} permission 权限标识
 * @returns {boolean}
 */
export function hasPermission(permission) {
  const user = getUser()
  if (!user) return false

  // 超级管理员拥有所有权限
  if (user.superAdmin === 1) return true

  // 获取用户权限列表
  const permissions = user.permissions || []
  
  // 支持通配符或者精确匹配
  return permissions.some(p => {
    return p === '*:*:*' || p === permission
  })
}

/**
 * 判断是否有角色
 * @param {string} roleCode 角色代码
 * @returns {boolean}
 */
export function hasRole(roleCode) {
  const user = getUser()
  if (!user) return false

  // 超级管理员
  if (user.superAdmin === 1 && roleCode === 'superAdmin') return true

  return user.roleCode === roleCode
}
